<div class="gutter">
<header #header class="flx-col flx-gap-default">
		<h1 #headerTitle *ngIf="pageTitle">{{ pageTitle }}</h1>
		<a [routerLink]="['/'+path_list]" class="hide-md" *ngIf="!initial" i18n="@@gobackcat">wróć do kategorii</a>
</header>

<div class="flx-dynamic">
<ul class="categories hide-xs" [class.intro]="initial">
	<ng-template #recursiveList let-children>
		<ng-container *ngFor="let page of children; let i = index">
			<li *ngIf="allowed.includes(+page.visible)">
				<a [routerLink]="['/'+page?.path]" routerLinkActive="active"><img *ngIf="page.extra_field_3" class="icon-svg" [src]="cdn +'/pages/'+ page.photos_directory + '/' + page.extra_field_3">{{ page.name }}</a>
			</li>
		</ng-container>
	</ng-template>
	<ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: categories }"></ng-container>
</ul>


<div class="flx-col wikis">
	<ng-container *ngIf="!outlet.isActivated">
		<div *ngFor="let wiki of wikis; let i = index" >
			<ul>
				<li>
				<a [routerLink]="[wiki.path]">{{ wiki.name }}</a>
				</li>
			</ul>		
		</div>
	</ng-container>

	<router-outlet #outlet="outlet" (deactivate)="deactivate($event)"></router-outlet>
</div>


</div>


</div>
